"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardModuleChildPath = void 0;
exports.DashboardModuleChildPath = {
    profile: 'profile',
    tools: 'tools',
    accounts: 'accounts',
    portfolio: 'portfolio',
    activityLog: 'activity-log',
    faq: 'faq',
    firstMonthExperience: 'next-steps',
    contributeCash: 'contribute-cash',
    withdrawalCash: 'withdraw-cash',
    scheduledTransfers: 'scheduled-transfers',
    myPlan: 'my-plan'
};
